import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {UnsubscribeOnDestroyAdapter} from '@shared';
import {DefaultResponse} from "@core/models/Http/DefaultResponse";
import {environment} from "@enviroment/environment";
import {HealthEvent} from "@core/models/HealthEvent";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";
import {MsgResponse} from "@core/models/MsgResponse";


@Injectable({
  providedIn: 'root',
})

export class HealthEventService extends UnsubscribeOnDestroyAdapter {
  isTblLoading = true;
  dataChange: BehaviorSubject<HealthEvent[]> = new BehaviorSubject<HealthEvent[]>([]);
  dialogData!: HealthEvent;

  constructor(
    private httpClient: HttpClient,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();
  }

  get data(): HealthEvent[] {
    return this.dataChange.value;
  }

  getDialogData() {
    return this.dialogData;
  }

  /** CRUD METHODS */
  getAllHealthEvents(): void {
    this.subs.sink = this.httpClient.get<DefaultResponse<HealthEvent[]>>(
      `${environment.backend_url}CatEventosDeSalud/CateventosSalud`,).subscribe({
      next: (data) => {
        this.isTblLoading = false;
        this.dataChange.next(data.data);

      },
      error: (error: HttpErrorResponse) => {
        this.isTblLoading = false;
        this.httpMsgHandler.handleMsg(error);
      },
    });
  }

  addHealthEvent(healthEvent: HealthEvent): void {
    this.httpClient.post(`${environment.backend_url}CatEventosDeSalud/CateventosSalud`, healthEvent)
      .subscribe({
        next: (res) => {
          this.httpMsgHandler.handleMsg(res as MsgResponse);
        },
        error: (error: HttpErrorResponse) => {
          this.httpMsgHandler.handleMsg(error);
        },
      });
  }

  updateHealthEvent(healthEvent: HealthEvent): void {
    this.httpClient.put(`${environment.backend_url}CatEventosDeSalud/CateventosSalud/${healthEvent.idEvento}`, healthEvent)
      .subscribe({
        next: (res) => {
          this.httpMsgHandler.handleMsg(res as MsgResponse);
        },
        error: (error: HttpErrorResponse) => {
          this.httpMsgHandler.handleMsg(error);
        },
      });
  }

  deleteHealthEvent(id: string): void {
    this.httpClient.delete(`${environment.backend_url}CatEventosDeSalud/CateventosSalud/${id}`)
      .subscribe({
        next: (res) => {
          this.httpMsgHandler.handleMsg(res as MsgResponse);
        },
        error: (error: HttpErrorResponse) => {
          this.httpMsgHandler.handleMsg(error);
        },
      });
  }

}
